import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import FlyerPrintButtonAfterRegistration from './FlyerPrintButtonAfterRegistration';

loadDOMComponent({
	selector: 'react-flyer-print-button-after-registration',
	callback: ({ container, context }: any) => {
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<FlyerPrintButtonAfterRegistration patientId={patientId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
